let IconSize = /*#__PURE__*/function (IconSize) {
  IconSize["SIZE_SMALL"] = "small";
  IconSize["SIZE_MEDIUM"] = "medium";
  IconSize["SIZE_REGULAR"] = "regular";
  IconSize["SIZE_LARGE"] = "large";
  IconSize["SIZE_EXTRA_LARGE"] = "extra_large";
  return IconSize;
}({});

export { IconSize };
//# sourceMappingURL=size.js.map
